export enum ChannelStatusEnum {
  NEW = 'new',
}
